<template>
  <div class="m-search-bar">
    <div class="search-box">
      <div class="back-slot">
        <slot name="prepend"></slot>
      </div>

      <el-input v-model="keyword" ref="input" class="search-input" @keyup.native.enter="changeHandle" :clearable="true"> </el-input>
      <el-button @click="changeHandle" class="search-btn" :icon="loading ? 'el-icon-loading' : 'el-icon-search'"></el-button>
      <slot name="append"></slot>
    </div>
    <div class="options-box">
      <el-tabs @tab-click="changeHandle" v-model="tabIndex">
        <el-tab-pane v-for="item in tabs" :key="item.label" :label="item.label"></el-tab-pane>
      </el-tabs>
      <div class="sort-box" v-if="showSort">
        <svg-icon name="time" @click.native="toggleSort('time')" :class="[sort === 'time' && 'active']" title="按时间排序"></svg-icon>
        <svg-icon @click.native="toggleSort('like')" name="good" :class="[sort === 'like' && 'active']" title="按点赞数排序"></svg-icon>
      </div>
    </div>
  </div>
</template>
<script>
import Tab from "./tags";
export default {
  data() {
    return {
      keyword: "",
      tabIndex: "-1",
      sort: ""
    };
  },
  methods: {
    toggleSort(value) {
      this.sort = this.sort === value ? "" : value;
      this.changeHandle();
    },
    changeHandle() {
      this.$emit("change", {
        keyword: this.keyword,
        tab: this.tags,
        orderby: this.sort
      });
    },
    searchFromUrl() {
      const { type, keyword } = this.$route.query;
      this.keyword = keyword;
      this.tabIndex = this.tabs.findIndex(item => type === item.value).toString();
    }
  },
  computed: {
    tags() {
      if (this.tabIndex === "-1") {
        return "";
      }
      return this.tabs[this.tabIndex].label;
    },
    inform() {
      return JSON.stringify(this.$store.state.inform);
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        this.searchFromUrl();
      }
    }
  },
  props: {
    loading: {
      type: Boolean,
      default() {
        return false;
      }
    },
    tabs: {
      type: Array,
      default() {
        return Tab;
      }
    },
    showBack: {
      type: Boolean,
      default() {
        return true;
      }
    },
    showSort: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  mounted() {
    this.$nextTick(() => this.$refs.input.focus());
  }
};
</script>
<style lang="scss">
.m-search-bar {
  background-color: #fff;
  border-bottom: 1px solid #dbdbdb;
  .search-box {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
    height: 32px;
    background-color: #5e5e5e;
    $height: 28px;
    .back-slot {
      cursor: pointer;
      color: #fff;
      padding: 0 10px;
      flex-shrink: 0;
      font-size: 14px;
      white-space: nowrap;
    }
    .search-input {
      width: 100%;
      .el-input__inner {
        height: $height;
        border-radius: 2px;
        border-top-right-radius: 0px;
        border-bottom-right-radius: 0px;
      }
    }
    .search-btn {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      background-color: #ced0da;
      height: $height;
      color: #ccc;
      background: linear-gradient(360deg, #f2f4f8 0%, #feffff 100%);
      border-radius: 0;
      padding: 0px 20px;
    }
  }
  .options-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #f5f5f5;
  }
  .el-tabs {
    padding-left: 10px;
    display: flex;
    align-items: center;
    .el-tabs__nav-wrap::after {
      background-color: transparent;
    }
    .el-tabs__item {
      display: inline-flex;
      align-items: center;
      height: 30px;
      padding: 0 10px;
      font-size: 12px;
      font-weight: normal;
    }
  }
  .sort-box {
    svg {
      margin-right: 10px;
      fill: #666;
      font-size: 14px;
    }
    .active {
      fill: #ee7700;
    }
  }
  .search-types {
    display: flex;
    flex-wrap: wrap;
    > span {
      cursor: pointer;
      padding: 15px;
      display: inline-flex;
      flex-wrap: nowrap;
      width: 25%;
      justify-content: center;
      font-size: 14px;
      color: #666;
    }
  }
}
</style>
